<script setup lang="ts">
definePageMeta({
  middleware: ['auth'],
})

const { data } = await useApi('/training/progression', { key: 'training-progression' })
</script>

<template>
  <UiPage
    v-if="data"
    padding
    :title="$t('Training Dashboard')"
    :description="$t('View your progress and challenges!')"
  >
    <template #top-below>
      <training-toolbar />
    </template>
    <div class="flex flex-col gap-4">
      <UiAlert
        :title="$t('Welcome to the training beta dashboard!')"
        variant="warning"
      >
        <template #description>
          <p>{{ $t('Training is currently in early beta. We encourage you to try it out and provide feedback!') }}</p>
          <p>{{ $t('Your feedback will help us shape the training experience for you!') }}</p>
          <p>{{ $t('Ideas for games, challenges and more are welcome!') }}</p>
          <p>{{ $t('You can send your feedback via email to') }} <a href="mailto:feedback@dartsspace.com">feedback@dartsspace.com</a></p>
        </template>
      </UiAlert>
      
      <UiCard
        :title="$t('Challenges')"
      >
        <template #content>
          <UiCardContent>
            <TrainingChallengesDisplay :data="data" />
          </UiCardContent>
        </template>
      </UiCard>
      <UiCard
        :title="$t('Progression')"
      >
        <template #content>
          <UiCardContent>
            <TrainingProgressionDisplay :data="data" />
          </UiCardContent>
        </template>
      </UiCard>
    </div>
  </UiPage>
</template>
